module.exports = __webpack_public_path__ + "img/poches-off.87419e34.svg";